// ======================================================================
// File Name       : ContentDrillRegisterAddQuestion
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form, FormControl, Modal, Table } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import MessageSearch from '../../components/MessageSearch';
import SelectBox from '../../components/SelectBox';
import {
  AUTH_REDIRECT_URL, DRILL_CLIENT_URL, MODAL_SIZE, PREVIEW_QUESTION_WINDOW_NAME,
  QUESTION_CONVERT_ERROR_URL, QUESTION_DETAIL_WINDOW_NAME, VALIDATE_TYPE, X_SSAPI_VERSION
} from '../../constants';
import { CONVERT_STATUS } from '../../constants/ContentConstant';
import { CONTENT_QUESTION_DETAIL_PREVIEW } from '../../constants/PathConstants';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getItemBoxName } from '../../utils/index';
import CustomButton from '../button/CustomButton';
import PaginationCustom from '../Pagination';
import TableHead, { setSortState } from '../TableHead';
import QuestionAttributeDialog from './QuestionAttributeDialog';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';

class contentDrillRegisterAddQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      isAllowShowSearchMessage: false,
    };
    this.validation = this.validation.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.openPreviewQuestion = this.openPreviewQuestion.bind(this);
    this.openDetailQuestionNewWindows = this.openDetailQuestionNewWindows.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  handleSearch() {
    const isValid = this.validation();
    if (isValid) {
      this.props.handleDialogSearch();
    }
  }
  getStartEndData(startPosition) {
    const isValid = this.validation();
    if (isValid) {
      this.props.dialogGetStartEndData(startPosition);
    }
  }
  handleSortState(row) {
    const isValid = this.validation();
    if (isValid) {
      this.props.handleSearchSortState(row);
    }
  }

  handleIsChecked(questionList, selectedQuestionList, isDisabled) {
    if (
      questionList &&
      questionList.length &&
      selectedQuestionList &&
      selectedQuestionList.length
    ) {
      for (let i = 0; i < questionList.length; i++) {
        const index = selectedQuestionList.indexOf(questionList[i].questionSecernId);
        if (index > -1) {
          if (!questionList[i].isChecked) {
            questionList[i].isChecked = true;
            questionList[i].isDiable = isDisabled;
          }
        }
      }
    }
    return questionList;
  }

  openPreviewQuestion(previewQuestionLink) {
    const newWindow = window.open(previewQuestionLink, PREVIEW_QUESTION_WINDOW_NAME, 'height=750,width=1000,menubar=no,toolbar=no,scrollbars=yes,resizable=yes');
    newWindow.focus();
  }

  openDetailQuestionNewWindows(questionSecernId) {
    const path = CONTENT_QUESTION_DETAIL_PREVIEW.replace(':id', questionSecernId);
    const newWindow = window.open(path, QUESTION_DETAIL_WINDOW_NAME, 'height=750,width=1000,menubar=no,toolbar=no,scrollbars=yes,resizable=yes');
    newWindow.focus();
  }

  render() {
    const {
      openPreviewEachQuestionAttribute,
      attributeListData,
      handleChangeOption,
      attributeOptions,
      isClosed,
      buttonText,
      openOrCloseAttributeArea,
      handleChangeTextAttribute,
      attributeText,
      addAttribute,
      number,
      removeAttributeSearch,
      institutionId,
      handleCheckAll,
    } = this.props;
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const thead = [
      { title: '', sortBy: null, width: 50 },
      { title: '問題識別ID', sortBy: 0 },
      { title: '問題名', sortBy: 1 },
      { title: '問題種別', sortBy: null, width: 110 },
      { title: '配点', sortBy: null, width: 90 },
      { title: '操作', sortBy: null, width: 110 },
    ];
    this.refsToValidate = [];
    let questionSearchResultTableData = null;
    if (this.props.dialogSearchResult && this.props.dialogSearchResult.questionList) {
      const isEdit = this.props.isEdit;
      let list = [];
      list = this.handleIsChecked(
        this.props.dialogSearchResult.questionList,
        this.props.existQuestionList,
        true,
      );
      // set is checked for selected question temporary
      list = this.handleIsChecked(
        this.props.dialogSearchResult.questionList,
        this.props.questionDataListTemp,
        false,
      );
      if (list && list.length) {
        questionSearchResultTableData = list.map(
          (question, index) => {
            // #7155 START
            const previewQuestionLink = `${DRILL_CLIENT_URL}/QuestionPreviewHtml?institution_id=${institutionId}&question_secern_id=${question.questionSecernId}&auth_redirect_uri=${AUTH_REDIRECT_URL}&X-SSapi-version=${X_SSAPI_VERSION}&convert_redirect_uri=${QUESTION_CONVERT_ERROR_URL}`;
            // #7155 END
            // If question is completed conversion, プレビュー button is displayed.
            const isCompletedConversion = (question.convertStatus === CONVERT_STATUS.CONVERSION_SUCCESS);
            return (
              <tr key={index}>
                <td>
                  <Form.Check
                    type='checkbox'
                    className="padding-clear margin-top-4"
                    checked={
                      question.isChecked ? question.isChecked : false
                    }
                    onChange={this.props.handleCheckbox.bind(
                      this,
                      question.questionSecernId,
                    )}
                    disabled={question.isDiable ? question.isDiable : false} />
                </td>
                <td>
                  {question.questionSecernId}
                </td>
                <td>
                  {question.questionTitle}
                </td>
                <td>
                  {getItemBoxName(
                    SELECT_BOX_DATA.QUESTION_TYPE,
                    question.questionKind,
                  )}
                </td>
                <td className="text-center">
                    {question.absolutePoint && `${question.absolutePoint}点`}
                </td>
                <td className="text-center">
                  <Button
                    className="btn-96"
                    variant="primary"
                    onClick={this.openDetailQuestionNewWindows.bind(this, question.questionSecernId)}
                  >
                    詳細
                  </Button>
                  {isCompletedConversion &&
                    <Button
                      className="margin-top-5 btn-96"
                      variant="primary"
                      onClick={this.openPreviewQuestion.bind(this, previewQuestionLink)}
                    >
                      プレビュー
                    </Button>
                  }
                </td>
              </tr>
            );
          },
        );
      }
    }
    const sortBy = this.props.questionSortType;
    const sortState = this.props.ascendingDescendingSort;
    const data = setSortState(thead, sortBy, sortState);

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onDialogCancel} closeButton>
          <Modal.Title className="text-center">問題を追加してください</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <MessageSearch
              recordNum={this.props.recordNum}
              resultList={
                this.props.dialogSearchResult ? this.props.dialogSearchResult.questionList : []
              }
              isAllowShowSearchMessage={this.props.isAllowShowSearchMessage}
              dismissMessage={this.props.dismissMessage}
            />
            <Form className='form-horizontal'>
              <Form.Group
                className="form-info"
                controlId="formHorizontalDialogContentId"
              >
                <Col as={Form.Label} sm={3}>
                  問題識別ID
                </Col>
                <Col sm={6}>
                  <FormControlValidate
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    type="text"
                    name="questionSecernId"
                    value={this.props.questionSecernId}
                    maxLength="64"
                    label="問題識別ID"
                    validateType={VALIDATE_TYPE.ID}
                    onChange={this.props.handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                className="form-info"
                controlId="formHorizontalDialogContentName"
              >
                <Col as={Form.Label} sm={3}>
                  問題名
                </Col>
                <Col sm={6}>
                  <FormControl
                    type="text"
                    maxLength="256"
                    name="questionTitle"
                    onChange={this.props.handleChange}
                    value={this.props.questionTitle}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                className="form-info"
                controlId="formHorizontalDialogContentType"
              >
                <Col as={Form.Label} sm={3}>
                  問題種別
                </Col>
                <Col sm={6}>
                  <SelectBox
                    data={SELECT_BOX_DATA.QUESTION_TYPE_HAVE_BLANK}
                    name="questionKind"
                    value={this.props.questionKind}
                    onChange={this.props.handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info margin-top-20">
                <Col sm={3} as={Form.Label} className="padding-left-5">
                  <a role="presentation" className={buttonText} onClick={openOrCloseAttributeArea}>
                  問題属性
                  </a>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} className="padding-left-15">
                  <Button
                    variant="link"
                    className="padding-left-clear padding-top-2"
                    onClick={openPreviewEachQuestionAttribute}
                  >
                    ※問題属性一覧
                  </Button>
                </Col>
              </Form.Group>
              {!isClosed &&
              <QuestionAttributeDialog
                attributeListData={attributeListData}
                handleChangeOption={handleChangeOption}
                attributeOptions={attributeOptions}
                attributeText={attributeText}
                handleChangeTextAttribute={handleChangeTextAttribute}
                addAttribute={addAttribute}
                number={number}
                removeAttributeSearch={removeAttributeSearch}
              />
              }
              <Form.Group className="form-info">
                <Col className="text-center">
                  {/* <Button
                    bsStyle="primary"
                    className="btn-96 text-center"
                    onClick={this.handleSearch}
                  >
                    search
                  </Button> */}
                  <CustomButton
                    btnStyle="btn btn-primary btn-96 margin-bottom-10"
                    handleClick={this.handleSearch}
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Form.Group>
              { questionSearchResultTableData &&
                <>
                  <Col sm={2} className="margin-top-15 margin-bottom-10 padding-left-clear">
                    <Button variant="default" className="btn btn-default btn-96" onClick={handleCheckAll}>
                      全選択/解除
                    </Button>
                  </Col>
                  <Col sm={10} className="margin-top-15 padding-right-10">
                    <PaginationCustom
                      className="float-end"
                      recordNum={this.props.recordNum}
                      handlePageSelect={this.getStartEndData}
                      resetPage={this.props.dialogResetPage}
                      startPosition={this.props.startPosition}
                    />
                  </Col>
                  <Col>
                    <Table striped hover className="margin-top-10">
                      <thead>
                        <TableHead data={data} handleSortState={this.handleSortState} />
                      </thead>
                      <tbody>{questionSearchResultTableData}</tbody>
                    </Table>
                  </Col>
                </>
              }
              { questionSearchResultTableData == null &&
                <div className="text-center padding-top-60 background-dark-blue bold">
                  <p>
                    ドリルに紐づけられる問題がありません。<br />
                    まずは問題を作成してください。
                  </p>
                  <CustomLink
                    className="margin-right-7 btn-register margin-top-15 margin-bottom-55"
                    to={Path.CONTENT_QUESTION_REGISTER}
                    onClick={this.props.saveActiveTabMenu}
                    text="問題を作成する"
                    icon={ICON.REGIST}
                  />
                </div>
              }
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button
            variant="default"
            className=" margin-right-10 btn btn-default btn-96"
            onClick={this.props.onDialogCancel}
          >
            キャンセル
          </Button>
          <Button
            className=" margin-left-10 btn-96"
            variant="primary"
            onClick={this.props.onDialogOK}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default contentDrillRegisterAddQuestion;
